import { parseToCSV } from './parse-to-csv';
export var generateSelectedRowsCSVData = function (_a) {
    var selectedRows = _a.selectedRows, columnsKeys = _a.columnsKeys, _b = _a.columnsNamesMapping, columnsNamesMapping = _b === void 0 ? {} : _b, addColumnNames = _a.addColumnNames;
    var parsedElements = [];
    if (addColumnNames) {
        var columnNames = columnsKeys.map(function (columnKey) {
            if (Object.keys(columnsNamesMapping).includes(columnKey)) {
                return columnsNamesMapping[columnKey];
            }
            return columnKey;
        });
        parsedElements.push(columnNames);
    }
    selectedRows.forEach(function (row) {
        var parsedRow = columnsKeys.map(function (columnKey) {
            var columnValue = row[columnKey].value;
            if (Array.isArray(columnValue)) {
                return columnValue.toString();
            }
            return columnValue;
        });
        parsedElements.push(parsedRow);
    });
    return parseToCSV(parsedElements, ';');
};
